import { useTranslation } from 'react-i18next'
import { KebabCase } from 'type-fest'

import { SectionTab } from 'components/Tabs'
import { Workspace } from 'features/workspace'
import { KWordsForm } from './Sections/KWordsSection/Form'
import { MultiAnchorForm } from './Sections/MultiAnchorSection/Form'

export type RichPlacementsUrlParams = Partial<{
  section: SectionRouteParam
  workspaceId: Workspace['id']
}>

export type SectionRouteParam = KebabCase<'k-words' | 'multi-anchor'>

export const useSectionTabs = (): SectionTab<SectionRouteParam>[] => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.sections',
  })

  return [
    {
      element: 'multi-anchor',
      label: t('multiAnchor'),
      page: <MultiAnchorForm />,
    },
    {
      element: 'k-words',
      label: t('kWords'),
      page: <KWordsForm />,
    },
  ]
}
